import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-support',
    imports: [],
    templateUrl: './support.component.html'
})
export class SupportComponent {
  public supportEmail = environment.support.email
}
